import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [],
  templateUrl: './app-redirect.component.html',
  styleUrl: './app-redirect.component.css'
})
export class AppRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  redirectToMROPortal(): void {
    window.location.href = environment.MRO_PORTAL_URL;
  }

}
